import React from "react";

const RouteErrorFallback = ({ resetError }) => {
  const handleReload = () => {
    resetError();
    window.location.reload();
  };

  return (
    <div className="flex justify-center items-center min-h-[60vh]">
      <div className="space-y-3 text-center">
        <h1 className="text-3xl font-bold text-custom-focus-color">
          Something went wrong
        </h1>
        <h3 className="text-custom-light-grey text-lg">
          We've been notified and are looking into it. Please reload the
          page and try again.
        </h3>
        <button
          type="button"
          onClick={handleReload}
          className="inline-flex justify-center rounded-md bg-custom-link-bg-color px-4 py-2 text-sm font-semibold text-white shadow-sm"
        >
          Reload page
        </button>
      </div>
    </div>
  );
};

export default RouteErrorFallback;
